import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { Interview } from '@app/models/recruiting/interview.model';
import { AnalyticService } from '@app/services';
import { JobPostingCreateInterviewActions } from '../../enums/job-posting-create-interview-actions.enum';

@Component({
    selector: 'app-job-posting-create-interview-dialog',
    templateUrl: './job-posting-create-interview-dialog.html',
    styleUrls: ['./job-posting-create-interview-dialog.style.scss'],
})
export class JobPostingCreateInterviewDialogComponent implements OnInit {
    @Input() openDialog = false;

    @Output() createApplicantInterview = new EventEmitter();
    @Output() closeApplicantCreateInterviewDialog = new EventEmitter();
    jobPostingCreateInterviewActions = JobPostingCreateInterviewActions;
    selectedCreateAction = JobPostingCreateInterviewActions.fromExistingInterview;
    selectedExistingInterview = null;
    existingInterviews = [];

    constructor(private analyticService: AnalyticService) {}

    async ngOnInit(): Promise<void> {
        const [existingInterviews] = await Interview.with(['jobPosting']).all();
        this.existingInterviews = existingInterviews;
    }

    onCancel(): void {
        this.selectedExistingInterview = null;
        this.closeApplicantCreateInterviewDialog.emit();
    }

    onCreate(): void {
        if (this.selectedCreateAction === JobPostingCreateInterviewActions.fromScratch) {
            this.analyticService.trackEvent(AnalyticEvents.RecruitngJobPostingInterviewsCreateInterviewFromScratch);
            this.selectedExistingInterview = null;
        }

        if (this.selectedCreateAction === JobPostingCreateInterviewActions.fromExistingInterview) {
            this.analyticService.trackEvent(AnalyticEvents.RecruitingJobPostingInterviewsCreateInterviewFromExisting);
        }

        this.createApplicantInterview.emit(this.selectedExistingInterview);
    }
}
